import { ReduceStore } from 'flux/utils';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';
import { Record, Map } from 'immutable';

export const Styling = Record({
  appName: 'Blue',
  logo: 'bluelabs-full-med.png',
  theme: null,
  subTitle: '',
});

function loadStylingsFromUser(state, user) {
  const newValues = new Map(user.memberships.map(membership =>
    [membership.organization.id, new Styling(membership.detail.styling)])
  );
  return state.merge(newValues);
}

class StylingStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_LOADED:
        return state.set(action.organization.id,
          new Styling(action.organization.organization_detail.styling));
      case Constants.Admin.CURRENT_USER_LOADED:
        return loadStylingsFromUser(state, action.user);
      default:
        return state;
    }
  }

  getForOrganization(orgId) {
    return this.getState().get(orgId, new Styling());
  }
}

const instance = new StylingStore(AppDispatcher);
export default instance;
